<template>
    <!-- Modal backdrop -->
    <div class="modal-backdrop" @click.self="close">
      <!-- Modal content box -->
      <div class="modal-content">
        <!-- Close button -->
        <button class="modal-close-button" @click="close">✕</button>
  
        <h3>Select Existing Equipment</h3>
  
        <!-- Equipment list -->
        <ul class="equipment-list">
          <li v-for="(eq, index) in equipmentList" :key="index">
            <button
              class="equipment-item-button"
              @click="select(eq)"
            >
              {{ eq.location }} – {{ eq.name }} ({{ eq.type }})<br>
              Brand: {{ eq.brand }}<br>
              Model: {{ eq.model }}<br> 
                Serial: {{ eq.serial }}
            </button>
          </li>
        </ul>
      </div>
    </div>
  </template>
  
  <script>
  export default {
    name: 'SelectEquipmentModal',
    props: {
      equipmentList: {
        type: Array,
        required: true,
      },
    },
    methods: {
      // Emit the selected equipment object
      select(equipment) {
        this.$emit('select', equipment);
      },
      // Emit close event to hide the modal
      close() {
        this.$emit('close');
      },
    },
  };
  </script>
  
  <style scoped>
  /* Full-screen semi-transparent backdrop */
  .modal-backdrop {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1000;
  }
  
  /* Centered modal box */
  .modal-content {
    background-color: white;
    border-radius: 8px;
    padding: 1.5rem;
    width: 90%;
    max-width: 400px;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.3);
    position: relative;
  }
  
  /* Close “✕” button in top-right corner */
  .modal-close-button {
    position: absolute;
    top: 0.5rem;
    right: 0.5rem;
    background: transparent;
    border: none;
    font-size: 1.25rem;
    cursor: pointer;
  }
  
  /* Equipment list styling */
  .equipment-list {
    list-style: none;
    margin: 1rem 0 0;
    padding: 0;
  }
  
  .equipment-list li + li {
    margin-top: 0.5rem;
  }
  
  /* Each equipment item as a button */
  .equipment-item-button {
    width: 100%;
    text-align: left;
    background-color: #f5f5f5;
    border: none;
    padding: 0.5rem 0.75rem;
    border-radius: 4px;
    cursor: pointer;
    transition: background-color 0.1s ease-in-out;
  }
  
  .equipment-item-button:hover {
    background-color: #e0e0e0;
  }
  </style>
  